<template>
  <div id="translations h-full">
    <div id="translations_topBar" class="w-9/10 mx-auto px-1 text-left relative">
      <div class="flex">
        <input v-model="searchInput" type="text" :placeholder="getTranslation('search')"
               class="border-shadow rounded-20 search mb-2 pl-2 py-2 search mr-1">
        <div class="inline ">
          <div class="flex align-middle h-9/10 items-center cursor-pointer"
               @click="showOnlyEmpty = !showOnlyEmpty">
            <custom-checkbox :selected="showOnlyEmpty" class="ml-5"/>
            <p class="p-0 m-0">
              {{ getTranslation('onlyMissingTranslations') }}</p>
          </div>
        </div>
      </div>
      <div class="absolute right-0 top-0">
        <button @click="addFieldsToAddLanguage()"
                v-if="editableTranslations.length === 0 && canAddTranslations()"
                class="classen__button classen__button_active ml-1 px-3">
          <p class=" leading-none">+ {{ getTranslation('addLanguage') }}</p>
        </button>
        <button @click="showAddTranslationPopup=true"
                v-if="editableTranslations.length === 0 && canAddTranslations()"
                class="classen__button classen__button_active ml-1 px-3">
          <p class=" leading-none">+ {{ getTranslation('addTranslation') }}</p>
        </button>
        <button @click="addAllTranslationsInEditableTranslations()"
                v-if="editableTranslations.length === 0 && canEditTranslations()"
                class="classen__button classen__button_active ml-1 px-3">
          <p class=" leading-none"> + {{ getTranslation('editTranslations') }}</p>
        </button>

        <button @click="save()"
                v-if="editableTranslations.length > 0"
                class="classen__button classen__button_active ml-1 px-3">
          <p class=" leading-none"> {{ getTranslation('save') }}</p>
        </button>
        <button @click="cancel()"
                v-if="editableTranslations.length > 0"
                class="classen__button classen__button_active ml-1 px-3">
          <p class=" leading-none">{{ getTranslation('cancel') }}</p>
        </button>
      </div>
    </div>
    <div id="translations_table_div" class="w-full h-9/10 text-left w-9/10 mx-auto">
      <div
        class="flex flex-row font-bold h-1/20 border-b-2 border-classen__secondary items-center justify-items-start">
        <p class="flex-1">
          {{ getTranslation('key') }}
        </p>

        <div v-if="languages.length <= 3" v-for="language in languages" class="flex-1">
          <input v-model="language.code" type="text" :placeholder="getTranslation('code')"
                 v-if="language.id === -1"
                 class="bg-gray translation-input__field translation-input__field__code"/>
          <input v-model="language.name" type="text" :placeholder="getTranslation('language')"
                 v-if="language.id === -1"
                 class="bg-gray translation-input__field translation-input__field__language"/>
          <div class="flex align-middle">
            <p v-if="language.id > -1" class="language_code">{{ getTranslation(language.code) }}</p>
            <button
              @click="activateLanguage(language.id)"
              v-if="!language.isActive && language.id" class="classen__button ml-2 activate_button">
              <p class="p-0 m-0">{{ getTranslation('activateLanguage') }}</p>
            </button>
          </div>
        </div>

        <div v-if="languages.length > 3 && !addLanguage" class="flex-1">
          <c-option-dropdown :options="languagesInDropdown"
                             :selectedOption.sync="selectedLanguage"></c-option-dropdown>
          <button
            @click="activateLanguage(selectedLanguage.id)"
            v-if="!selectedLanguage.isActive && selectedLanguage.id"
            class="classen__button ml-2 activate_button">
            <p class="p-0 m-0">{{ getTranslation('activateLanguage') }}</p>
          </button>
        </div>

        <div v-if="languages.length > 3 && addLanguage" class="flex-1">
          <input v-model="getNewLanguage().code" type="text" :placeholder="getTranslation('code')"
                 class="bg-gray translation-input__field translation-input__field__code"/>
          <input v-model="getNewLanguage().name" type="text"
                 :placeholder="getTranslation('language')"
                 class="bg-gray translation-input__field translation-input__field__language"/>
          <p v-if="getNewLanguage().id > -1">{{ getTranslation(getNewLanguage().code) }}</p>
        </div>
      </div>
      <div class="h-19/20 overflow-y-auto">
        <div v-if="languages.length <= 3" v-for="translation in paginatedTranslations"
             class="flex flex-row h-1/20 justify-items-start items-center my-2 mt-4">
          <div class="flex-1 flex justify-between mr-10">
            <p class="mr-5 w-9/10">{{ translation.key }}</p>
            <div v-if="canEditTranslations()"
                 class="action bg-classen__primary flex justify-center items-center text-white w-1/10"
                 @click="isPopupConfirmCancelVisible=true; translationToDelete=translation;">
              <i class="fas fa-trash"></i>
            </div>
          </div>

          <div v-for="language in translation.languages" class="flex-1 flex justify-between mr-10">
            <input v-model="language.value" type="text"
                   v-if="editableTranslationsIncludesValue(translation.key, language.id)"
                   class="mr-5 bg-gray translation-input__field translation-input__field__value"/>
            <p v-if="!editableTranslationsIncludesValue(translation.key, language.id)"
               class="mr-5 ml-1">
              {{ language.value }}
            </p>
            <div class="action bg-classen__primary flex justify-center items-center text-white"
                 v-if="editableTranslations.length === 0"
                 @click="addToEditableTranslations(translation.key, language.id)">
              <i class="fas fa-pen"></i>
            </div>
          </div>
        </div>

        <div v-if="languages.length > 3" v-for="translation in paginatedTranslations"
             class="flex flex-row h-1/20 justify-items-start items-center my-2">
          <div class="flex-1 flex justify-between mr-10">
            <p class="mr-5 w-9/10">{{ translation.key }}</p>
            <div v-if="canDeleteTranslations()"
                 class="action bg-classen__primary flex justify-center items-center text-white w-1/10"
                 @click="isPopupConfirmCancelVisible=true; translationToDelete=translation;">
              <i class="fas fa-trash"></i>
            </div>
          </div>

          <div v-if="getTranslationInSelectedLanguage(translation) !== undefined"
               class="flex-1 flex justify-between mr-10">
            <input v-model="getTranslationInSelectedLanguage(translation).value" type="text"
                   v-if="editableTranslationsIncludesValue(translation.key, getTranslationInSelectedLanguage(translation).id)"
                   class="mr-5 bg-gray translation-input__field translation-input__field__value"/>
            <p
              v-if="!editableTranslationsIncludesValue(translation.key, getTranslationInSelectedLanguage(translation).id)"
              class="mr-5">
              {{ getTranslationInSelectedLanguage(translation).value }}
            </p>
            <div class="action bg-classen__primary flex justify-center items-center text-white"
                 v-if="editableTranslations.length === 0"
                 @click="addToEditableTranslations(translation.key, getTranslationInSelectedLanguage(translation).id)">
              <i class="fas fa-pen"></i>
            </div>
          </div>
        </div>

        <div v-if="hasMore" class="flex justify-center">
          <button class="classen__button hover__button col"
                  @click="page+=1">
            {{ getTranslation('loadMoreItems') }}
          </button>
        </div>
      </div>
    </div>

    <c-loader v-if="!isLoaded"></c-loader>

    <c-add-translation-popup v-if="showAddTranslationPopup" @cancel="showAddTranslationPopup=false;"
                             @confirm="reloadTranslations()"/>

    <c-confirm-popup
      v-if="isPopupConfirmCancelVisible"
      :phrase="getTranslation('areYouSureYouWantToDeleteThisTranslation')"
      :confirmText="getTranslation('yesDelete')"
      :cancelText="getTranslation('cancel')"
      @confirm="deleteTranslation()"
      @cancel="cancel()"
    />
  </div>
</template>

<script>
import getTranslation from "../mixins/getTranslation";
import getPermissions from "../mixins/getPermissions";
import AddTranslationPopup from "./AddTranslationPopup";
import Input from "../components/form/Input";
import OptionDropdown from "../components/structure/OptionDropdown";
import ConfirmationPopup from "../components/form/ConfirmationPopup";
import Loader from "../components/Loader";
import CustomCheckbox from "../components/form/CustomCheckbox";

export default {
  name: 'Translations',

  mixins: [getTranslation, getPermissions],

  data() {
    return {
      searchInput: '',
      showOnlyEmpty: false,

      editableTranslations: [],
      translationToDelete: null,

      isPopupConfirmCancelVisible: false,
      showAddTranslationPopup: false,
      addLanguage: false,

      selectedLanguage: {value: -1, name: 'Choose a language'},

      isLoaded: true,
      page: 1,
    }
  },

  components: {
    CustomCheckbox,
    Input,
    'c-add-translation-popup': AddTranslationPopup,
    'c-option-dropdown': OptionDropdown,
    'c-confirm-popup': ConfirmationPopup,
    'c-loader': Loader,
  },

  watch: {
    showOnlyEmpty() {
      console.log(this.showOnlyEmpty)
    }
  },

  computed: {
    languages() {
      return this.$dashboardStore.getters.getLanguages;
    },

    languagesInDropdown() {
      let languagesInDropdown = [];
      this.languages.forEach((language) => {
        languagesInDropdown.push({
          value: language.id,
          name: language.code,
          isActive: language.isActive,
          id: language.id,
        });
      });
      return languagesInDropdown;
    },

    allTranslations() {
      return this.$dashboardStore.getters.getAllKeysWithTranslations.map((translation) => {
        return {
          key: translation.key,
          languages: translation.languages,
          hasMissingKey: !translation.languages.every((language) => language.value)
        }
      });
    },

    filteredTranslations() {
      let translations = this.allTranslations;

      if (this.showOnlyEmpty) {
        translations = translations.filter((translation) => translation.hasMissingKey);
      }

      if (this.searchInput === '') {
        return translations;
      }

      return translations.filter((translation) => {
        return translation.key.toLowerCase().includes(this.searchInput.toLowerCase());
      });
    },

    paginatedTranslations() {
      let amountOfTranslationsVisible = this.page * 50;
      return this.filteredTranslations.slice(0, amountOfTranslationsVisible);
    },

    hasMore() {
      return this.paginatedTranslations.length <= this.filteredTranslations.length && this.filteredTranslations.length > 50;
    }
  },

  methods: {
    async activateLanguage(languageId) {
      await this.$dashboardStore.dispatch('activateLanguage', {languageId});
      this.reloadTranslations();
    },

    save() {
      this.isLoaded = false;
      if (this.addLanguage) {
        this.saveNewLanguage();
        return;
      }

      this.editableTranslations.forEach((editableTranslation) => {
        const translation = this.allTranslations.find((translation) => translation.key === editableTranslation.key);
        const language = translation.languages.find((language) => language.id === editableTranslation.languageId);

        const newTranslation = {
          id: language.translationId,
          key: translation.key,
          value: language.value,
          languageId: language.id
        }

        if (newTranslation.id !== null && newTranslation.id >= 0) {
          this.editTranslation(newTranslation);
        }

        if (newTranslation.id === null || newTranslation.id < 0) {
          this.createTranslation(newTranslation);
        }
      });
    },

    saveNewLanguage() {
      const language = this.languages.find((language) => language.id === -1);
      if (language === undefined || language.code === null || language.code > 2 || language.name === null) {
        this.reloadTranslations()
        return;
      }

      this.$dashboardStore.dispatch('addLanguage', language).then((response) => {
        let languageId = response.data.id;
        this.editableTranslations.forEach((editableTranslation) => {
          const translation = this.allTranslations.find((translation) => translation.key === editableTranslation.key);
          const language = translation.languages.find((language) => language.id === editableTranslation.languageId);

          const newTranslation = {
            key: translation.key,
            value: language.value,
            languageId: languageId
          }

          if (newTranslation.value) {
            this.createTranslation(newTranslation);
          }

          this.reloadTranslations();
        });
      });
    },

    sortTranslationLanguages(translationLanguages) {
      translationLanguages.sort((a, b) => {
        if (a.id === -1) {
          return 1;
        }

        if (b.id === -1) {
          return -1;
        }

        return a.id - b.id;
      });
    },

    cancel() {
      this.reloadTranslations();
    },

    async reloadTranslations() {
      this.editableTranslations = [];
      this.addLanguage = false;
      this.showAddTranslationPopup = false;
      this.isPopupConfirmCancelVisible = false;
      await this.$dashboardStore.dispatch('forceReloadLanguages')
      await this.$dashboardStore.dispatch('forceReloadTranslations');

      if (!this.selectedLanguage) {
        this.isLoaded = true;
        return
      }
      const data = await this.$dashboardStore.dispatch('getLanguagesFresh');

      const updatedLanguage = data.find((language) => {
        return language.id === this.selectedLanguage.id
      });

      if (!updatedLanguage) {
        return;
      }

      this.selectedLanguage = {
        value: updatedLanguage.id,
        name: updatedLanguage.code,
        isActive: updatedLanguage.isActive,
        id: updatedLanguage.id,
      }

      this.isLoaded = true;
    },

    createTranslation(translation) {
      this.$dashboardStore.dispatch('addTranslation', translation).then(() => {
        this.reloadTranslations();
        this.isLoaded = true;
      }).catch(() => {
        this.warning = "somethingWentWrong";
      });
    },

    editTranslation(translation) {
      this.$dashboardStore.dispatch('updateTranslation', {
        translationId: translation.id,
        translationData: translation
      }).then(() => {
        this.reloadTranslations();
      }).catch(() => {
        this.warning = "somethingWentWrong";
      });
    },

    addFieldsToAddLanguage() {
      this.languages.push({code: null, id: -1, name: null});
      this.allTranslations.forEach((translation) => {
        translation.languages.push({id: -1, translationId: -1, value: null});
        this.addToEditableTranslations(translation.key, -1);
      });
      this.selectedLanguage = {value: -1, name: null};
      this.addLanguage = true;
    },

    getNewLanguage() {
      return this.languages.find((language) => language.id === -1);
    },

    addToEditableTranslations(key, languageId) {
      let editableTranslation = {
        key: key,
        languageId: languageId
      }

      if (!this.editableTranslations.includes(editableTranslation)) {
        this.editableTranslations.push(editableTranslation);
      }
    },

    editableTranslationsIncludesValue(key, languageId) {
      return this.editableTranslations.some((editableTranslation) => {
        return editableTranslation.key === key && editableTranslation.languageId === languageId;
      });
    },

    addAllTranslationsInEditableTranslations() {
      this.allTranslations.forEach((translation) => {
        translation.languages.forEach((language) => {
          this.addToEditableTranslations(translation.key, language.id);
        });
      });
    },

    getTranslationInSelectedLanguage(translation) {
      return translation.languages.find((language) => language.id === this.selectedLanguage.value);
    },

    deleteTranslation() {
      if (this.translationToDelete !== null) {
        this.translationToDelete.languages.forEach((language) => {
          this.$dashboardStore.dispatch('deleteTranslation', language.translationId)
            .then(() => this.reloadTranslations());
        });
      }
    },

    deleteTranslationInLanguage(translationId) {
      this.$dashboardStore.dispatch('deleteTranslation', translationId)
        .then(() => this.reloadTranslations());
    },

    canAddTranslations() {
      return this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN])
        || this.flexibleHasPermissionToAddTranslations();
    },

    canEditTranslations() {
      return this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN, this.ROLES.REGIONAL_ADMIN])
        || this.flexibleHasPermissionToEditTranslations();
    },

    canDeleteTranslations() {
      return this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN])
        || this.flexibleHasPermissionToDeleteTranslations();
    }
  },
}
</script>

<style scoped>
.action {
  height: 40px !important;
  width: 40px !important;
  border-radius: 40px;
}

.translation-input__field {
  height: 40px;
}

.translation-input__field__value {
  width: 300px;
  margin-left: 1.5%;
}

.translation-input__field__code {
  width: 70px;
  margin-right: 10px;
  padding-left: 1.5%;
}

.translation-input__field__language {
  width: 220px;
  padding-left: 1.5%;
}

.activate_button {
  height: 30px;
  line-height: 25px;
}

.language_code {
  line-height: 30px;
}
</style>
